'use strict';

(function () {
  'use strict';

  /*** This comprises all of the widgets that can be rendered by a quiz
   ***/

  angular.module('msWidgets').directive('msWidgetQuizQuizDropDown', function () {
    return {
      templateUrl: 'widgets/templates/quiz/quiz_drop_down.html',
      controller: MsWidgetsQuizCtrl
    };
  }).directive('msWidgetQuizQuizCheckBoxes', function () {
    return {
      templateUrl: 'widgets/templates/quiz/quiz_check_boxes.html',
      controller: MsWidgetsQuizCtrl
    };
  }).directive('msWidgetQuizQuizRadioButtons', function () {
    return {
      templateUrl: 'widgets/templates/quiz/quiz_radio_buttons.html',
      controller: MsWidgetsQuizCtrl
    };
  });

  MsWidgetsQuizCtrl.$inject = ['$scope', 'userSvc', '$log'];

  function MsWidgetsQuizCtrl($scope, userSvc, $log) {
    //clear out previous responses
    // TODO: need to check if this line can be constantly removed
    //$scope.widget.response = null;
    $scope.saveQuizPreference = function (question) {
      var addTags = [];
      var removeTags = [];

      if (question.type === 'quiz/quiz_check_boxes') {
        setTagsForMultiSelect(question, addTags, removeTags);
      } else {
        setTagsForSingleSelect(question, addTags, removeTags);
      }

      if (addTags.length > 0 || removeTags.length > 0) {
        //save preferences if user exists
        userSvc.getUser().then(function (user) {
          if (user) {
            $log.debug('saving tagPreferences');
            removeTags = removeTags.filter(function (t) {
              return !addTags.includes(t);
            });
            userSvc.saveTagPreferences(addTags, removeTags);
          }
        });
      }
    };
  }

  function setTagsForSingleSelect(question, addTags, removeTags) {
    for (var i = 0; i < question.properties.answerCount; i++) {
      var prop = 'choice_' + i + '_preference';
      if (question.properties.hasOwnProperty(prop) && !_.isEmpty(question.properties[prop])) {
        if (question.response === i.toString()) {
          addTags.push(question.properties[prop]);
        } else {
          removeTags.push(question.properties[prop]);
        }
      }
    }
  }

  function setTagsForMultiSelect(question, addTags, removeTags) {
    var responses = question.response.split(',');
    for (var i = 0; i < question.properties.answerCount; i++) {
      var prop = 'choice_' + i + '_preference';
      if (question.properties.hasOwnProperty(prop) && !_.isEmpty(question.properties[prop])) {
        if (_.includes(responses, i.toString())) {
          addTags.push(question.properties[prop]);
        } else {
          removeTags.push(question.properties[prop]);
        }
      }
    }
  }
})();